/**
 * @description: IOS手势状态
 * @enum: disabled 1 禁用
 * @enum: enabled 2 启用
 */
export const IOS_GESTURE_STATUS = {disabled: 0, enabled: 1} as const
export type IOS_GESTURE_STATUS_CODE = VO<typeof IOS_GESTURE_STATUS>;
export type IOS_GESTURE_STATUS_NAME = keyof typeof IOS_GESTURE_STATUS;

/**
 * @description: 状态栏/导航栏显隐
 * @enum: hide 0 隐藏
 * @enum: show 1 显示
 */
export const BAR_STATUS = {hide: 0, show: 1} as const
export type BAR_STATUS_CODE = VO<typeof BAR_STATUS>;
export type BAR_STATUS_NAME = keyof typeof BAR_STATUS;

/**
 * @description: 分享渠道
 * @enum: wechat 0 微信好友
 * @enum: wechatMoments 1 朋友圈
 */
export const SHARE_CHANNEL = {wechat: 0, wechatMoments: 1}
export type SHARE_CHANNEL_CODE = VO<typeof SHARE_CHANNEL>;
export type SHARE_CHANNEL_NAME = keyof typeof SHARE_CHANNEL;

/**
 * @description: 是否是全屏状态
 * @enum: isFullscreen 1 全屏
 * @enum: isNotFullscreen 2 横屏
 */
export const FULLSCREEN_STATUS = {isFullscreen: 1, isNotFullscreen: 2} as const
export type FULLSCREEN_STATUS_CODE = VO<typeof FULLSCREEN_STATUS>;
export type FULLSCREEN_STATUS_NAME = keyof typeof FULLSCREEN_STATUS;

/**
 * @description: 图书权益码的状态
 * @enum: normal 0 失效
 * @enum: notReceived 1 权益没有被领取
 * @enum: frozen 2 已冻结
 * @enum: frozenConfirmed 3 冻结确认
 * @enum: notExist 5001 权益不存在
 * @enum: notReceived 5002 被自己领取
 * @enum: otherReceived 5003 被其他人领取
 */
export const EQUITY_CODE = {
    loseEfficacy: 0,
    notReceived: 1,
    frozen: 2,
    frozenConfirmed: 3,
    notExist: 5001,
    selfReceived: 5002,
    otherReceived: 5003,
} as const
export type EQUITY_CODE_CODE = VO<typeof EQUITY_CODE>;
export type EQUITY_CODE_NAME = keyof typeof EQUITY_CODE;

/**
 * @description: 图书权益码的冻结状态
 * @enum: loseEfficacy 0 失效
 * @enum: normal 1 正常
 * @enum: frozen 2 已冻结
 * @enum: frozenConfirmed 3 冻结确认
 */
export const EQUITY_FROZEN_STATUS = {
    loseEfficacy: 0,
    normal: 1,
    frozen: 2,
    frozenConfirmed: 3,
} as const
export type EQUITY_FROZEN_STATUS_CODE = VO<typeof EQUITY_FROZEN_STATUS>;
export type EQUITY_FROZEN_STATUS_NAME = keyof typeof EQUITY_FROZEN_STATUS;

/**
 * @description: 页面类型
 * @enum: normal 1 普通目录
 * @enum: game 2 游戏化目录
 */
export const PAGE_STATUS = {normal: 1, game: 2} as const
export type PAGE_STATUS_CODE = VO<typeof PAGE_STATUS>;
export type PAGE_STATUS_NAME = keyof typeof PAGE_STATUS;

/**
 * @description: 批改转改
 * @enum: noCorrection 0 没有批改
 * @enum: partialCorrection 1 部分批改
 * @enum: allCorrection 2 全部批改
 * @enum: noQuestion 3 没有题目
 */
export const CORRECTION_STATUS = {
    noCorrection: 0,
    partialCorrection: 1,
    allCorrection: 2,
    noQuestion: 3,
} as const
export type CORRECTION_STATUS_CODE = VO<typeof CORRECTION_STATUS>;
export type CORRECTION_STATUS_NAME = keyof typeof CORRECTION_STATUS;

/**
 * @description: 题目类型
 * @enum: right 1 正确
 * @enum: wrong 2 错误
 * @enum: noResult 4 没有结果
 * @enum: partiallyRight 12 部分正确
 * @enum: uncorrected 13 没有批改
 */
export const QUESTION_STATUS = {
    right: 1,
    wrong: 2,
    noResult: 4,
    partiallyRight: 12,
    uncorrected: 13,
} as const
export type QUESTION_STATUS_CODE = VO<typeof QUESTION_STATUS>;
export type QUESTION_STATUS_NAME = keyof typeof QUESTION_STATUS;

/**
 * @description: 按钮类型
 * @enum: scan 1 扫码看视频
 * @enum: photo 2 拍照批改
 */
export const BTN_TYPE = {scan: 1, photo: 2} as const
export type BTN_TYPE_CODE = VO<typeof BTN_TYPE>;
export type BTN_TYPE_NAME = keyof typeof BTN_TYPE;

/**
 * @description: app扫码页面type
 * @enum: onlyScan 0 仅有扫码看视频的扫码器
 * @enum: scanTab 1 打开扫码器定位在扫码看视频tab
 * @enum: photoTab 2 打开扫码器定位在拍照搜题tab
 */
export const SCAN_PAGE_TYPE = {onlyScan: 0, scanTab: 1, photoTab: 2} as const
export type SCAN_PAGE_TYPE_CODE = VO<typeof SCAN_PAGE_TYPE>;
export type SCAN_PAGE_TYPE_NAME = keyof typeof SCAN_PAGE_TYPE;

/**
 * @description:
 * @enum: isLogic_type 0
 * @enum: isNotLogic_type 1
 */
export const LOGIC_TYPE_ID = {
    // 互动题
    interactive: '0',
    // 选择
    choice: '1',
    // 多选
    multipleChoice: '2',
    // 不定项选择
    indefiniteChoice: '3',
    // 填空
    fillBlank: '4',
    // 解答
    explanation: '5',
    // 语音
    voice: '6',
    // 写作
    writing: '7',
    // 判断
    judge: '8',
    // 完形填空
    cloze: '9',
    // 复合题
    compound: '10',
    // 多选多
    multiChoiceMulti: '11',
    // 视频题
    video: '12',
    // 字词句朗诵
    wordRecitation: '13',
    // 古诗文朗诵
    poetryRecitation: '14',
    // 角色扮演
    rolePlay: '15',
} as const
export type LOGIC_TYPE_ID_CODE = VO<typeof LOGIC_TYPE_ID>;
export type LOGIC_TYPE_ID_NAME = keyof typeof LOGIC_TYPE_ID;

/**
 * @description: 反馈问题场景
 * @enum: 1 拍照批改
 * @enum: 2 写作题批改
 * @enum: 3 口算批改
 */
export enum problemSceneEnum{
  photo=1,
  write,
  mental
}

/**
 * @description: 反馈类型
 * @enum: 5 题目不正确
 * @enum: 6 解析不正确
 */
export enum defaultFeedbackEnum{
  question = 5,
  analysis = 6
}

